import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IDuplication {
  id: number | null;
  collectionName: string | null;
}

const initialState: IDuplication = {
  id: null,
  collectionName: null,
};

export const duplicationSlice = createSlice({
  name: "duplication",
  initialState,
  reducers: {
    setDupplicationInfo: (state, action: PayloadAction<IDuplication>) => {
      state.id = action.payload.id;
      state.collectionName = action.payload.collectionName;
    },
    resetDupplicationInfo: (state) => {
      state.id = initialState.id;
      state.collectionName = initialState.collectionName;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDupplicationInfo, resetDupplicationInfo } =
  duplicationSlice.actions;

export default duplicationSlice.reducer;
